import { useTranslation } from 'react-i18next';

import {
	ActionDecorations,
	ActionFeedback,
	ActionInput,
	ActionMedia,
	ActionSubmit,
	ActionText,
	AmountButton,
	GiverToggle,
	useActionInput,
} from '@bonusly/common-action-input';
import { Box, Flex, rem, Spacer, useBreakpointValue } from '@bonusly/design-system';

import { Bonus } from '../../../../../types/bonus';
import { useCommentEdit } from './hooks/use-comment-edit';
import { SuggestedComments } from './suggested-comments';

const DynamicStyledActionText = () => {
	const { attachment, isLoadingAttachment } = useActionInput();
	return <ActionText inputStyles={{ minHeight: attachment || isLoadingAttachment ? undefined : rem(150) }} />;
};

export interface CommentEditorProps {
	bonus: Bonus;
	onDone: VoidFunction;
	parentBonus: Bonus;
}

export const CommentEditor = ({ bonus, onDone, parentBonus }: CommentEditorProps) => {
	const { t } = useTranslation('recognition');
	const { isOwnRecognition, setInputText, ...config } = useCommentEdit(bonus, parentBonus, {
		onSuccess: onDone,
	});

	const suggestedMessageTitle = useBreakpointValue({
		base: 'bonus_input.quick_thank_you.mobile_title',
		sm: 'bonus_input.quick_thank_you.title',
	}) as any;

	const buttonLabel = 'bonus_input.quick_thank_you.generate';

	return (
		<Box w="full" ps={3}>
			<Box backgroundColor="white" borderRadius="md" boxShadow="sm" p={3} w="full">
				<ActionInput autofocus="end" {...config}>
					<Flex alignItems="center" columnGap={2}>
						<Box>
							<AmountButton />
						</Box>
						<GiverToggle />
					</Flex>

					<Box mb={2}>
						<DynamicStyledActionText />
						{isOwnRecognition && <SuggestedComments bonus={bonus} onSetText={setInputText} title={t(suggestedMessageTitle)} buttonLabel={t(buttonLabel)} />}
						<ActionFeedback />
					</Box>

					<ActionMedia w="full" />

					<Flex
						alignItems={{ base: 'stretch', xs: 'flex-start' }}
						direction={{ base: 'column', xs: 'row' }}
						gap={2}
						id="comment-editor-submit-container"
						justifyContent="space-between"
						my={2}
						w="full"
					>
						<ActionDecorations />
						<Spacer />
						<ActionSubmit size="lg">{t('save', { ns: 'common' })}</ActionSubmit>
					</Flex>
				</ActionInput>
			</Box>
		</Box>
	);
};
